import { render, staticRenderFns } from "./ChatBotModal.vue?vue&type=template&id=1f2512f1&scoped=true&"
import script from "./ChatBotModal.vue?vue&type=script&lang=js&"
export * from "./ChatBotModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotModal.vue?vue&type=style&index=0&id=1f2512f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2512f1",
  null
  
)

export default component.exports